import React from 'react';
import { motion } from 'framer-motion';
const lumpTypes = [{
  id: 'cyst',
  name: 'Cyst',
  description: 'A fluid-filled sac. Very common and usually harmless. Often resolves on its own.',
  titleClass: 'text-sky-700',
  bgClass: 'bg-sky-50',
  accentBg: 'bg-sky-400',
  svg: <svg viewBox="0 0 40 40" className="w-10 h-10 text-sky-500" data-id="element-546">
        <circle cx="20" cy="20" r="16" fill="currentColor" fillOpacity="0.2" data-id="element-547" />
        <path d="M4 20 Q 12 12, 20 20 T 36 20 A 16 16 0 0 1 4 20 Z" fill="currentColor" fillOpacity="0.6" data-id="element-548" />
      </svg>
}, {
  id: 'fibroadenoma',
  name: 'Fibroadenoma',
  description: 'A solid, smooth, benign growth. Most common in younger women. Not cancerous.',
  titleClass: 'text-emerald-700',
  bgClass: 'bg-emerald-50',
  accentBg: 'bg-emerald-400',
  svg: <svg viewBox="0 0 40 40" className="w-10 h-10 text-emerald-500" data-id="element-549">
        <ellipse cx="20" cy="20" rx="16" ry="12" fill="currentColor" fillOpacity="0.8" data-id="element-550" />
      </svg>
}, {
  id: 'fat-necrosis',
  name: 'Fat Necrosis',
  description: 'Damaged fatty tissue, often after injury or surgery. Feels firm but is harmless.',
  titleClass: 'text-amber-700',
  bgClass: 'bg-amber-50',
  accentBg: 'bg-amber-400',
  svg: <svg viewBox="0 0 40 40" className="w-10 h-10 text-amber-500" data-id="element-551">
        <path d="M12 12 Q 20 4, 28 12 T 32 24 Q 28 36, 20 32 T 8 24 Q 4 16, 12 12 Z" fill="currentColor" fillOpacity="0.7" data-id="element-552" />
      </svg>
}, {
  id: 'cancer',
  name: 'Cancer',
  description: 'Less common. When found early, treatment is very effective. Your clinic will check carefully.',
  titleClass: 'text-slate-700',
  bgClass: 'bg-slate-50',
  accentBg: 'bg-slate-300',
  svg: <svg viewBox="0 0 40 40" className="w-10 h-10 text-slate-400" data-id="element-553">
        <path d="M15 10 L 20 6 L 25 12 L 32 10 L 28 18 L 34 24 L 26 26 L 28 34 L 20 28 L 12 32 L 15 25 L 8 22 L 14 16 Z" fill="currentColor" fillOpacity="0.8" data-id="element-554" />
      </svg>
}];
export function LumpTypesVisual() {
  return <div className="flex flex-col space-y-5" data-id="element-555">
      {/* Reassuring Header Stat */}
      <div className="bg-nhs-blue/5 rounded-xl p-5 border border-nhs-blue/10 text-center shadow-sm" data-id="element-556">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} className="text-4xl font-bold text-nhs-blue mb-1 flex items-baseline justify-center space-x-2" data-id="element-557">
          <span data-id="element-558">9</span>
          <span className="text-xl font-medium text-nhs-blue/80" data-id="element-559">out of</span>
          <span data-id="element-560">10</span>
        </motion.div>
        <motion.p initial={{
        y: 5,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-nhs-darkblue font-medium text-lg" data-id="element-561">
          breast lumps are not cancer
        </motion.p>
      </div>

      {/* Lump Types List */}
      <div className="space-y-3" data-id="element-562">
        {lumpTypes.map((lump, index) => <motion.div key={lump.id} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.3 + index * 0.15,
        duration: 0.4
      }} className="flex items-start p-4 bg-white rounded-xl border border-slate-100 shadow-sm relative overflow-hidden" data-id="element-563">
            {/* Subtle left border accent */}
            <div className={`absolute left-0 top-0 bottom-0 w-1.5 ${lump.accentBg}`} data-id="element-564" />

            <div className={`flex-shrink-0 w-12 h-12 rounded-full ${lump.bgClass} flex items-center justify-center mr-4 ml-1`} data-id="element-565">
              {lump.svg}
            </div>

            <div className="flex-1" data-id="element-566">
              <h4 className={`font-bold text-base mb-1 ${lump.titleClass}`} data-id="element-567">
                {lump.name}
              </h4>
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-568">
                {lump.description}
              </p>
            </div>
          </motion.div>)}
      </div>

      {/* Footer Reassurance */}
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2
    }} className="text-center text-sm text-slate-500 italic mt-2 px-4" data-id="element-569">
        Your specialist team will determine the exact type during your visit.
      </motion.p>
    </div>;
}